var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"Trio-box-wrapper",attrs:{"href":"#","title":""},on:{"click":_vm.sendClickEvent}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }